import { PRODUCT_WORDMARK } from "../../../../shared/products/keys";
import { useActiveProduct } from "../../../hooks/useActiveProduct";
import { wordmarkVariantFor } from "../../../components/products/productTheme";

/**
 * The header wordmark follows the active product (spec §6, D14): inside the app shell the product
 * AppLayout resolved (a shared page such as Users keeps the product the user is in). The variant
 * follows the header it sits on, which is the same dark bar in every product (2026-10-08 shell
 * spec, D1), so it is the light (white-text) one everywhere (productTheme.ts). The asset paths live
 * in PRODUCT_WORDMARK (shared keys), the one place to swap the placeholder skyPerformance wordmark
 * for the real one; nothing here maps products to files.
 *
 * On hire the markup is exactly what it was before products existed (a bare <img>), so a hire-only
 * header is unchanged. The other wordmark is warmed by ProductSwitcher, only for users who switch.
 */
export function ProductWordmark({ className }: { className: string }) {
  const product = useActiveProduct();
  const logo = PRODUCT_WORDMARK[product];
  return (
    <img
      className={className}
      src={logo[wordmarkVariantFor(product)]}
      alt={logo.alt}
    />
  );
}

export function TenantLogo({ className = "h-7" }: { className?: string }) {
  return (
    <div className="flex items-center">
      <ProductWordmark className={className} />
    </div>
  );
}
